// Puerto del dominio (repository abstracto) para la consulta de vehículo/lead enriquecido.
import { Observable } from 'rxjs';
import {
  UpdateOwnerPayerInput,
  UpdateSelectedPlanInput,
  VehicleLookupInput,
  VehicleLookupResult,
} from '../../interfaces/vehicle-lookup/vehicle-lookup.interface';

export abstract class VehicleLookupRepository {
  abstract getVehicleData(input: VehicleLookupInput): Observable<VehicleLookupResult>;
  abstract updateOwnerAndPayer(input: UpdateOwnerPayerInput): Observable<VehicleLookupResult>;
  abstract updateSelectedPlan(input: UpdateSelectedPlanInput): Observable<VehicleLookupResult>;
}
